import React from 'react';
import { Page } from 'components/layouts/components';
import { Flex } from 'antd';
import useQueryParams from 'hooks/useQueryParams';
import JourneyReport from 'modules/ReportModule/context/JourneyReport';
import useWorkspace from 'store/redux/hooks/useWorkspace';
import TrafficReportingRecent from './components/TrafficReportingRecent';
import TrafficReportingEvents from './components/TrafficReportingEvents';

const UsersReporting = () => {
  const { workspace } = useWorkspace();
  const selected_website_id = localStorage.getItem(`selected_website_id_${workspace.id}`);

  const { searchParams } = useQueryParams();
  const { website_id } = searchParams;

  return (
    <Page className='relative'>
      <Flex vertical gap='large'>
        {(website_id || selected_website_id) && (
          <>
            <JourneyReport title='Recent Users' date_key='trafficReportingRecent'>
              <TrafficReportingRecent />
            </JourneyReport>
            <JourneyReport title='Events' date_key='trafficReportingEvents'>
              <TrafficReportingEvents />
            </JourneyReport>
          </>
        )}
      </Flex>
    </Page>
  );
};

export default UsersReporting;
